import GreenhouseGasMgmtReport from './GreenhouseGasMgmtReport';

export default GreenhouseGasMgmtReport;
